export const state = () => ({
  productRecommendationMap: new Map(),
  filterByPriceGroup: [],
  optimizerLanguage: 'alt1',
  indexedProductPrices: {},
  useOneService: false
});
